import { MockBackend } from './mock-backend';
import { RequestInfo, InMemoryDbService } from 'angular-in-memory-web-api';
import { Injectable } from '@angular/core';

import { AuthorzeMockService } from './services/authorize-mock.service';
import { HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BrandMockService } from './services/brand-mock.service';
import { ConfigMockService } from './services/config-mock.service';
import { RevokeMockService } from './services/revoke-mock.service';


@Injectable()
export class InMemoryBackend extends InMemoryDbService {

    private mockBackends: { path: RegExp, mock: MockBackend }[] = [];

    constructor() { super(); }

    public createDb(): {} {
        this.mockBackends.push({ path: AuthorzeMockService.PATH, mock: new AuthorzeMockService() });
        this.mockBackends.push({ path: BrandMockService.PATH, mock: new BrandMockService() });
        this.mockBackends.push({ path: ConfigMockService.PATH, mock: new ConfigMockService() });
        this.mockBackends.push({ path: RevokeMockService.PATH, mock: new RevokeMockService() });
        return {};
    }

    public get(reqInfo: RequestInfo): Observable<HttpResponse<any>> {

        const backend = this.getBackend(reqInfo.utils.getConfig().host, reqInfo.url, (reqInfo.req as any).urlWithParams);

        if (backend) {
            return backend.get({ req: reqInfo });

        }

        return null;
    }


    public put(reqInfo: RequestInfo): Observable<HttpResponse<any>> {

        const backend = this.getBackend(reqInfo.utils.getConfig().host, reqInfo.url, reqInfo.url);

        if (backend) {
            return backend.put({ req: reqInfo });

        }

        return null;
    }

    public post(reqInfo: RequestInfo): Observable<HttpResponse<any>> {

        const backend = this.getBackend(reqInfo.utils.getConfig().host, reqInfo.url, reqInfo.url);

        if (backend) {
            return backend.post({ req: reqInfo });

        }

        return null;
    }


    public delete(reqInfo: RequestInfo): Observable<HttpResponse<any>> {

        const backend = this.getBackend(reqInfo.utils.getConfig().host, reqInfo.url, reqInfo.url);

        if (backend) {
            return backend.delete({ req: reqInfo });

        }

        return null;
    }


    private getBackend(host: string, resourceUrl: string, url: string): MockBackend | undefined {
        const specialCharStripUrl = resourceUrl.replace(/[^\w\s]/gi, '');
        // console.log('InMemoryBackend getBackend called with url: ' + url, specialCharStripUrl, resourceUrl);
        if (specialCharStripUrl.startsWith(host)
            || specialCharStripUrl.startsWith('config')
            || specialCharStripUrl.startsWith('assets')) {
            const backend = this.mockBackends.find(o => o.path.test(url));
            return backend ? backend.mock : undefined;
        }
    }




}
